<LocationInput
  bind:searchString={searchString}
  hasValue={searchPromise || $store.searchResults.length > 0 || isNotAOI}
  isSearchDisabled={isSearchDisabled} 
  placeholder="Type in your suburb"
  showLabel={true}
  on:keyup={searchDebounced}
  on:focus={handleEnableSearch}
  on:focusout={handleDisableSearch}
  on:clear={clearSearch}
/>
<div class="suggestions-container">
  <LocationSuggestion
    searchPromise={searchPromise}
    isNotAOI={isNotAOI}
    on:goto={goTo}
  />
</div>




<script>
import store, { STATES_MAIN, STATES_START, STATES_FIRST_VISIT } from "../../state";
import utils from "../../utils";
import { debounce } from "ts-debounce";
import LocationSearchAPI from "./LocationSearchAPI";
import LocationInput from "./Input/Input.svelte";
LocationInput;
import LocationSuggestion from "./Suggestion/Suggestion.svelte";
LocationSuggestion;
const locationSearchAPI = new LocationSearchAPI();
// Props
export let isFtus;
// html vars
let searchString = "";
let searchPromise = undefined;
let isSearchDisabled = true;
let searchDebounced = debounce(handleSearch, 275);
let capitalize = utils.capitalize;
let isNotAOI = false;
let selectedSuburb = "";
store.subscribe(state => {
    var _a;
    const isInSearchingState = state.currentState.includes(`${STATES_MAIN.START}.${STATES_START.SEARCHING}`) ||
        state.currentState.includes(`${STATES_MAIN.FIRST_VISIT}.${STATES_FIRST_VISIT.SEARCHING}`);
    if (!isInSearchingState &&
        state.riskProfile &&
        state.riskProfile.Suburb !== selectedSuburb) {
        searchString = capitalize(state.riskProfile.Suburb).value();
        selectedSuburb = state.riskProfile.Suburb;
        isNotAOI = ((_a = state.riskProfile) === null || _a === void 0 ? void 0 : _a.AOI) === "OUT" || false;
    }
    else if (!isInSearchingState && !state.riskProfile) {
        selectedSuburb = "";
        searchString = "";
        isNotAOI = false;
    }
});
locationSearchAPI.store.subscribe(state => {
    isSearchDisabled = state.isSearchDisabled;
    searchPromise = state.searchPromise;
});
// html functions
function handleEnableSearch() {
    locationSearchAPI.handleEnableSearch(isFtus);
}
function handleDisableSearch() {
    // @ts-ignore
    if ($store.searchResults.length === 0) {
        locationSearchAPI.handleDisableSearch(isFtus);
    }
}
function handleSearch() {
    locationSearchAPI.handleSearch(searchString);
}
function goTo(event) {
    isNotAOI = false;
    locationSearchAPI.goTo(event.detail);
}
function clearSearch() {
    locationSearchAPI.clearSearch();
}
</script>


<style>.suggestions-container{position:relative}</style>
